// import Reader from './permisionReader.js'
export default {
  // mixins: [Reader],
  data() {
    return {
      PERMISIONS: {
        list: false,
        create: false,
        edit: false,
        enable: false,
        disable: false,
        delete: false,
        confirm: false
      }
    }
  },
  created() {
    const statuses = []
    const baseRule = 'products'

    this.initPermision(`${baseRule}.get`,'list',statuses)
    this.initPermision(`${baseRule}.post`,'create',statuses)
    this.initPermision(`${baseRule}.patch`,'edit',statuses)
    this.initPermision(`${baseRule}.enable`,'enable',statuses)
    this.initPermision(`${baseRule}.disable`,'disable',statuses)
    this.initPermision(`${baseRule}.delete`,'delete',statuses)
    this.initPermision(`${baseRule}.confirm`,'confirm',statuses)
  }
}